/**
 * Encodes lot attributes into the `key:value;key:value` format for tracking payloads.
 * Skips any attribute that's missing — the lot map inventory API can return `null` or `''`
 * for lotType/lotSize/lotFacing (see services/processLotMapInventory.js), and a trailing
 * `f:` with nothing after it is worse than just leaving that attribute out.
 *
 * @param {{ plansCount: number, lotType: string|null, lotSize: number|null, lotFacing: string|null }} params
 * @returns {string}
 */
export default function encodeLotAttributes({ plansCount, lotType, lotSize, lotFacing }) {
  return [
    ['c', plansCount],
    ['t', lotType],
    ['s', lotSize],
    ['f', lotFacing],
  ]
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}:${value}`)
    .join(';');
}
